module.exports = "/_next/static/images/mail-3977f790ea77370cc0ffc71a2a5f03c7.svg";